import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import DriverLogin from "src/sections/driver/DriverLogin";

type DriverGuardProps = {
  children: React.ReactNode;
};

export default function DriverGuard({ children }: DriverGuardProps) {
  const { ownerId } = useParams();
  const driverAuth = useSelector((state: RootState) => state.driverAuth);

  if (!driverAuth.accessToken) {
    return <DriverLogin ownerId={ownerId || ""} />;
  }

  return <>{children}</>;
}
